import moment from "moment";
import Vue from "vue";
import VModal from "vue-js-modal";
import VeeValidate from "vee-validate";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import SignUp from "./components/SignUp";
import Login from "./components/Login";
import NewPassword from "./components/NewPassword";
import ResetPassword from "./components/ResetPassword";
import Modal from "./components/Modal";
import axios from "axios";
import "./modules/filters";

window.defaultTitle = "Urbo Bankas | Open banking";
window.axios = axios;
window.moment = moment;
Vue.use(VeeValidate);
// Vue.use(VModal, {
//   dialog: true,
//   dynamic: true
// });
Vue.component("modal", Modal);
Vue.component("sign-up", SignUp);
Vue.component("login", Login);
Vue.component("reset", ResetPassword);
Vue.component("new-password", NewPassword);

Vue.config.productionTip = false;

let loader = store.dispatch("loadUserByToken");
loader
  .then(() => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  })
  .catch(error => {
    console.log(error);
  });
